import React from 'react';

import { eventsData } from 'data/javascript/events';

import DescriptionEntry from 'components/shared/description-entry';

const EventsBubbling = () => {
  const item = eventsData?.items.find(
    (item) => item.title === 'Event Bubbling and Capturing'
  );

  return <DescriptionEntry entry={item} />;
};

export default EventsBubbling;
